/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownTransform } from '../../CrownTransform';
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let Shape3DCircle = class Shape3DCircle extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        CrownTransform.copyMatrix(shape.pose, this);
        const geometry = Solids.createCircle(shape.radius);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide });
        this.addOutline(geometry, decoration);
    }
    format() {
        const { source, t, r, s, Matrix } = this.transformPose();
        return {
            radius: s.x * source.radius,
            pose: {
                Type: r.length() > 0 ? 'RIGID' : t.length() > 0 ? 'TRANSLATION' : 'IDENTITY',
                Matrix,
            },
        };
    }
};
Shape3DCircle = tslib_1.__decorate([
    Shape('Shape3D.Circle'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DCircle);
export { Shape3DCircle };
//# sourceMappingURL=Shape3DCircle.js.map